import { render, staticRenderFns } from "./mechanical-record.vue?vue&type=template&id=79ab376b&scoped=true&"
import script from "./mechanical-record.vue?vue&type=script&lang=js&"
export * from "./mechanical-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ab376b",
  null
  
)

export default component.exports